<template>
    <select>
        <slot></slot>
    </select>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";

</style>

<script type="text/babel">
    export default {
        props: ['options', 'value', 'placeholder', 'allowClear', 'initialValue', 'minimumResultsForSearch', 'dropdownParent'],

        mounted: function () {
            this.initSelect2();
        },

        watch: {
            /**
             * Refreshes selector when bound options change
             */
            options: function () {
                this.initSelect2();
            }
        },

        destroyed: function () {
            $(this.$el).off().select2('destroy')
        },

        methods: {
            initSelect2: function () {
                let vm = this;

                let $el = $(this.$el);

                // init select2
                $el.select2({
                    data: this.parseOptions(this.options),
                    placeholder: this.placeholder || '',
                    allowClear: this.allowClear || false,
                    minimumResultsForSearch: this.minimumResultsForSearch || 10,
                    dropdownParent: this.dropdownParent ? this.dropdownParent() : null,
                    escapeMarkup: function (markup) {
                        return markup;
                    }
                });

                $el.on('change', function (evt) {
                    $('.select2-selection__rendered').removeAttr('title');
                });

                // Required so that the initial value passed from parent is applied to the selector
                this.reset();

                // Notifies parent through the v-model binding
                $el.on('change', function () {
                    vm.$emit('input', this.value);
                    vm.$emit('change', this.value);
                });
            },

            /**
             * Supports input arrays of pairs key: value
             *
             * @param options
             * @returns {Array}
             */
            parseOptions: function (options) {
                return _.map(options, function (item, key) {
                    if (_.isString(item)) {
                        return {
                            id: key,
                            text: item
                        }
                    }

                    return item;
                });
            },

            /**
             * Public API.
             *
             */
            reset: function () {
                $(this.$el).val(this.initialValue || this.value);
                $(this.$el).trigger('change');
            },

            /**
             * Public API.
             * Null values won't clear the selector, it expects a '0'
             */
            clear: function () {
                $(this.$el).select2('val', '0');
            }
        }
    };
</script>